module.exports = __webpack_public_path__ + "media/images/icons/flags/CX-4c39b7a24621a85cef12f2b1771ef235.svg";